const courseListingsOverlay = document.getElementById('loading-overlay');
const courseFilterForm = document.getElementById('Form_Courses');
const courseListings = document.getElementById('course-listings');
const resetButton = document.getElementById('clearsearch');

document.addEventListener('DOMContentLoaded', () => {
    repopulateForm().then(() => {
        initFormActions();
        updateCourseResults();
    });
});

function saveFormValues() {
    const data = {};
    let formFields = courseFilterForm.querySelectorAll(':scope input, :scope select');

    formFields.forEach(inputField => {
        let fieldName = inputField.name;
        if (inputField.type === 'submit') {
            return;  // Skip the submit button
        }
        if (inputField.type === 'radio' || inputField.type === 'checkbox') {
            data[fieldName] = inputField.checked;
        } else {
            data[fieldName] = inputField.value;
        }
    });

    sessionStorage.setItem('filterValues', JSON.stringify(data));
}

function repopulateForm() {
    return new Promise((resolve) => {
        let formFields = courseFilterForm.querySelectorAll(':scope input, :scope select');
        let formData = JSON.parse(sessionStorage.getItem('filterValues')) || {};

        //console.log('Restoring data', formData);

        formFields.forEach(inputField => {
            const fieldName = inputField.name;
            if ((inputField.type === 'submit') || (inputField.type === 'reset')) {
                return;  // Skip the submit button
            }
            if (inputField.dataset.reqsearch === 'yes') {
                //We have an incoming search.  Don't overwrite it
                return;
            }
            if (inputField.type === 'radio' || inputField.type === 'checkbox') {
                inputField.checked = formData[fieldName] === true;
            } else {
                inputField.value = formData[fieldName] || '';
            }
        });

        resolve();
    });
}

function initFormActions() {
    courseFilterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        saveFormValues();
        cleanUpURL();
        updateCourseResults();
    });

    courseFilterForm.addEventListener('reset', function(e) {
        setTimeout(() => {
            saveFormValues();
            cleanUpURL();
            updateCourseResults();
        }, 100);
    });
}

function cleanUpURL() {
// Get the current URL
    const currentUrl = window.location.href;

// Construct the new URL without the query string
    const newUrl = window.location.origin + window.location.pathname;

// Update the browser history
    window.history.replaceState({}, document.title, newUrl);
}

function updateCourseResults() {
    //console.log("Getting results");
    courseListings.classList.add('loading');
    courseListingsOverlay.classList.add('loading');
    let resURL = courseFilterForm.dataset.u;
    let FD = new FormData(courseFilterForm);

    fetch(resURL, {
        method: 'POST',
        body: FD,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('There was a problem getting the results.  Please try again');
            }
            return response.text();
        })
        .then(content => {
            courseListings.innerHTML = content;
            courseListings.classList.remove('loading');
            courseListingsOverlay.classList.remove('loading');
        })
        .catch(error => {
            console.error("There was a problem fetching results:", error);
        });
}
